export default function DailyAdvice() {
  return (
    <section className="py-8 px-8">
      <div className="max-w-6xl mx-auto">
        <div className="relative bg-[#1a2332] rounded-[32px] overflow-hidden">
          {/* Patrón decorativo */}
          <div className="absolute top-0 left-0 w-64 h-64 opacity-5">
            <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
              <path fill="#ffd166" d="M44.7,-76.4C58.8,-69.2,71.8,-59.1,79.6,-45.8C87.4,-32.5,90,-16.2,88.5,-0.9C87,14.4,81.4,28.8,73.1,41.8C64.8,54.8,53.8,66.4,40.4,73.2C27,80,11.2,82,-4.8,79.8C-20.8,77.6,-41.6,71.2,-56.8,60.2C-72,49.2,-81.6,33.6,-85.2,16.4C-88.8,-0.8,-86.4,-19.6,-78.8,-35.8C-71.2,-52,-58.4,-65.6,-43.2,-72.4C-28,-79.2,-10.4,-79.2,3.6,-85.2C17.6,-91.2,30.6,-83.6,44.7,-76.4Z" transform="translate(100 100)" />
            </svg>
          </div>

          <div className="grid md:grid-cols-3 gap-0">
            {/* Imagen Leo García */}
            <div className="md:col-span-1 relative">
              <div className="absolute inset-0 md:relative md:h-full">
                <img
                  src="https://static.readdy.ai/image/7061ed29c8e51ecc6793f804431b5d06/cabd6a38ed9542c00878146cc55096f1.png"
                  alt="Leo García"
                  className="w-full h-full object-cover md:rounded-l-[32px]"
                />
              </div>
            </div>

            {/* Contenido del consejo */}
            <div className="md:col-span-2 p-12 md:p-16 relative">
              {/* Comillas decorativas */}
              <div className="absolute top-8 right-8 w-20 h-20 flex items-center justify-center">
                <i className="ri-double-quotes-l text-6xl text-[#ffd166] opacity-40"></i>
              </div>

              <div className="relative z-10">
                <h2 className="text-5xl font-bold text-white mb-8">
                  Protección Estratégica
                </h2>

                <div className="space-y-6 text-white text-xl leading-relaxed">
                  <p>
                    Un plan financiero sólido tiene dos pilares: <strong>ahorro y protección</strong>. Ahorrar sin un seguro de gastos médicos o de vida es como construir una casa hermosa sin cimientos.
                  </p>
                  
                  <p>
                    Mi <span className="text-[#ffd166] font-semibold">Método FEP (Finanzas Educadas y Protegidas)</span> se encarga de que tu ahorro crezca, pero que también esté blindado ante imprevistos.
                  </p>

                  <p className="text-base text-white/80 pt-4 italic">
                    — Leo García, Asesor Financiero
                  </p>
                </div>

                <button className="mt-10 bg-[#ff8fa3] text-[#1a2332] px-8 py-4 rounded-full font-semibold hover:bg-[#ffd166] transition-all cursor-pointer whitespace-nowrap">
                  Aprende Más sobre FEP
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}